import { IconRepeat, IconCreditCard, IconReceipt2, IconGift, IconUsers } from "@tabler/icons-react";
import type { ComponentInput } from "../../apis/chargeContract";

type ComponentType = ComponentInput["componentType"];

const ICON: Record<ComponentType, React.FC<{ size?: number }>> = {
  RECURRING_SUBSCRIPTION  : IconRepeat,
  ONE_TIME_PURCHASE       : IconCreditCard,
  TRANSACTION_FEE         : IconReceipt2,
  FREE_OR_CUSTOM          : IconGift,
  END_CUSTOMER_RECURRING  : IconUsers,
};

const LABEL: Record<ComponentType, string> = {
  RECURRING_SUBSCRIPTION  : "Тогтмол захиалга",
  ONE_TIME_PURCHASE       : "Нэг удаагийн төлбөр",
  TRANSACTION_FEE         : "Гүйлгээний шимтгэл",
  FREE_OR_CUSTOM          : "Үнэгүй/Тусгай",
  END_CUSTOMER_RECURRING  : "Эцсийн хэрэглэгчийн давтамжит",
};

export function ComponentTypeIcon({ type, size = 18 }: { type: string; size?: number }) {
  const Cmp = (ICON as Record<string, React.FC<{ size?: number }>>)[type] ?? IconReceipt2;
  return <Cmp size={size} />;
}

export function componentTypeLabel(type: string): string {
  return (LABEL as Record<string, string>)[type] ?? type;
}

const ORDER_TYPE_LABEL: Record<string, string> = {
  B2B_ORDER       : "B2B захиалга",
  AGGREGATOR_ORDER: "Агрегатор захиалга",
  INTERNAL_TRADING: "Дотоод арилжаа",
  RESELLER_ORDER  : "Дилерийн захиалга",
};

export function orderTypeLabel(code: string): string {
  return ORDER_TYPE_LABEL[code] ?? code;
}

